// extracted by mini-css-extract-plugin
export var colorSquare = "_q0-0";
export var danger = "_q0-5";
export var lightPink = "_q0-8";
export var neutralBlue = "_q0-7";
export var neutralYellow = "_q0-6";
export var normal = "_q0-1";
export var primary = "_q0-2";
export var primaryLight = "_q0-3";
export var solidBlack = "_q0-g";
export var solidGreen = "_q0-b";
export var solidLightBlue = "_q0-d";
export var solidNavy = "_q0-c";
export var solidOrange = "_q0-f";
export var solidPink = "_q0-e";
export var solidRed = "_q0-9";
export var solidYellow = "_q0-a";
export var success = "_q0-4";